/* 🤖 this file was generated by script */
export const wiconErp = {
  name: 'erp',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M14.12 15.12v-4.3m0 0V5h1.4c.83 0 1.5.56 1.5 1.61v2.57c0 1.05-.67 1.63-1.5 1.63h-1.4zm-4.22 0c.82 0 1.49-.6 1.49-1.64V6.61C11.39 5.56 10.72 5 9.9 5H8.5v5.81m1.4 0H8.5m1.4 0c.47.44 1.41 1.55 1.41 2.55v1.76m-2.81-4.3v4.3M5.97 5H4.5C3.67 5 3 5.56 3 6.61v3.44m2.97 5.07H4.5c-.82 0-1.49-.59-1.49-1.63v-3.44m0 0h1.74"/></svg>`,
};
